import React from "react";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const PerformanceAnalysisChampionCircle = (props) => {
  const { getChampionImg } = getRiotAssetsContext();
  const { champID, statText, label, secondaryText } = props.data;
  const largeStyle = props.isLarge ? "large" : "";

  const champURL = getChampionImg(champID);
  return (
    <div className={`champion-circle-container ${largeStyle}`}>
      <div className={`champion-circle`}>
        <img className="champion-circle-img" src={champURL} />
      </div>
      <div className="champ-text-container">
        <div className="small-header">{statText}</div>
        <div className="basic-text">{label}</div>

        {secondaryText && <div className="small-line-break" />}
        {secondaryText && <div className="basic-text">{secondaryText}</div>}
      </div>
    </div>
  );
};

export const PerformanceAnalysisSummonerCircle = (props) => {
  const { getProfileIconImg } = getRiotAssetsContext();
  const { iconID, statText, label, summonerName } = props.data;
  const largeStyle = props.isLarge ? "large" : "";

  const imgURL = getProfileIconImg(iconID);
  return (
    <div className={`champion-circle-container ${largeStyle}`}>
      <div className={`champion-circle`}>
        <img className="champion-circle-img" src={imgURL} />
      </div>
      <div className="summoner-text-container">
        <div className="small-header">{summonerName}</div>
        <div className="large-header">{statText}</div>
        <div className="basic-text">{label}</div>
      </div>
    </div>
  );
};

export default PerformanceAnalysisChampionCircle;
